const modules = {
  dashboard: "DASHBOARD",
};

export default modules;
